import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from 'react-redux'
import { useParams, Link } from "react-router-dom";
import '../../styles/calendar.css'
import { InlineWidget } from "react-calendly";
import { getPractitionerUsers } from "../../features/auth/authSlice";
import {
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
} from 'mdb-react-ui-kit';

const CalendarPage = () => {
  const { practitionerUsers } = useSelector((state) => state.auth)
  const [practitioner, setPractitioner] = useState({})
  // const [title, setTitle] = useState("");
  // const [start, setStart] = useState(new Date());
  // const [end, setEnd] = useState(new Date());
  const dispatch = useDispatch()


  const params = useParams()

  useEffect(() => {
    const user = practitionerUsers.find(item => item._id === params.id)
    
    setPractitioner(user)
  }, [practitionerUsers])

  useEffect(() => {
    if(practitionerUsers.length === 0){
      dispatch(getPractitionerUsers())
    }
  }, [])


  // const calendarRef = useRef(null)
  // const onEventAdded = (event) => {
  //     let calendarApi = calendarRef.current.getApi();
  //     calendarApi.addEvent(event);
  //     console.log(event)
  // }

//   function onSubmit(event) {
//     event.preventDefault();
//     onEventAdded({
//         title:title,
//         start:start,
//         end:end,
//     })
// }
// const [basicModal, setBasicModal] = useState(false);

// const toggleShow = () => setBasicModal(!basicModal);
console.log(practitioner)
  return (
    <div>
        <h1 className='text-center p-4 text-al fs-40'>{practitioner?.firstName} {practitioner?.lastName}'s Calendar is coming soon</h1>

        
 {/* {practitioner.calendlyUrl ? <InlineWidget url={`https://calendly.com/${practitioner?.calendlyUrl}`}/> : <p>This practitioner has not set up their booking system with us yet. Please check again later for booking!</p>  } */}
    
        {/* <MDBBtn onClick={toggleShow}>Book Appointment</MDBBtn>
      <MDBModal show={basicModal} setShow={setBasicModal} tabIndex='-1'>
        <MDBModalDialog>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Modal title</MDBModalTitle>
              <MDBBtn className='btn-close ' color='none' onClick={toggleShow}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
            <form onSubmit={onSubmit}>
                    <input placeholder="title" value={title} onChange={event => setTitle(event.target.value)}></input>
            <div className="d-flex">
                    <div>
                        <label>Start</label>
                        <Datetime value={start} onChange={date => setStart(date)} />
                    </div>
                    <div>
                        <label>end</label>
                        <Datetime value={end} onChange={date => setEnd(date)} />
                    </div>
        </div>
                    <MDBBtn color='secondary' onClick={toggleShow}>
                Close
              </MDBBtn>
              <MDBBtn type="submit">Save changes</MDBBtn>
                </form>
            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>


      <div className="p-5">
      <FullCalendar
        plugins={[ dayGridPlugin ]}
        initialView="dayGridMonth"
        ref={calendarRef}
      />
      </div> */}
        
    </div>
  )
}

export default CalendarPage